import React, { useEffect, useState } from "react";
import "./shiftDetails.scss";

import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import HeaderBar from "../../components/headerBar/HeaderBar";
import ShiftInfoBox from "../../components/shiftInfoBox/ShiftInfoBox";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import VolunteerDetails from "../../components/volunteerDetails/VolunteerDetails";
import CustomDialog from "../../components/customDialog/CustomDialog";

import {
  confirmSubscriptionShiftWS,
  deleteShiftWS,
  getShiftDetailsWS,
  removeSubscriptionVolunteerWS,
} from "./api/shiftDetailsApi";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import { Col, Dropdown, Row, Stack } from "react-bootstrap";
import { isEmpty } from "../../utils/validation";
import { gestioneSnackbar } from "../../utils/common";
import { WaitingUserBox } from "./components/waitingUserBox/WaitingUserBox";
import moment from "moment";

const ShiftDetails = () => {
  const navigate = useNavigate();
  const { id_event, id_shift } = useParams();
  const [searchParams] = useSearchParams();
  const id_association = searchParams.get("admin");

  const [data, setData] = useState({});

  const refreshContent = () => {
    getShiftDetailsWS(id_shift)
      .then((res) => setData(res))
      .catch((err) => console.log(err));
  };

  const handleClick = (id, confirmed) => {
    confirmSubscriptionShiftWS({ id_user_shift: id, confirmed })
      .then((res) => {
        gestioneSnackbar(true, res.message, "success");
        refreshContent();
      })
      .catch((err) => gestioneSnackbar(true, err.message, "error"));
  };

  useEffect(() => {
    refreshContent();
  }, [id_shift, id_association]);

  return (
    <>
      <HeaderBar title={t("shift_details.title")} back={true} />
      <div className="container-responsive shift-details-container d-flex justify-content-center">
        <Row sm={1} lg={2} className="w-100 g-3">
          {/*Dettagli del turno */}
          {!isEmpty(data) ? (
            <Col sm={12} lg={6} className="">
              <Stack direction="vertical " gap={2}>
                <Stack
                  direction="horizontal"
                  className="d-flex justify-content-between align-items-center"
                >
                  <span className="title-shift">{data.title}</span>
                  <Dropdown>
                    <Dropdown.Toggle
                      as="button"
                      variant="light"
                      id="dropdown-menu"
                      className="bg-transparent border-0 p-0"
                    >
                      {/* Solo la tua icona personalizzata */}
                      <MoreVertOutlinedIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ zIndex: 2 }}>
                      <Dropdown.Item
                        onClick={() =>
                          navigate(
                            `/dashboard/${id_association}/create-event/?id_event=${id_event}`
                          )
                        }
                      >
                        {t("shift_details.options.edit")}
                      </Dropdown.Item>

                      <CustomDialog
                        title={t("shift_details.remove_shift_modal.title")}
                        body={t("shift_details.remove_shift_modal.description")}
                        textClose={t("common.cancel")}
                        textCallToAction={t("common.confirm")}
                        trigger={
                          <Dropdown.Item>
                            {t("shift_details.options.delete")}
                          </Dropdown.Item>
                        }
                        callback={() => {
                          deleteShiftWS(id_shift)
                            .then((res) => {
                              gestioneSnackbar(true, res.message, "success");
                              navigate(-1);
                            })
                            .catch((err) =>
                              gestioneSnackbar(true, err.title, "error")
                            );
                        }}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                </Stack>
                <p className="w-100">{data.description}</p>
                <ShiftInfoBox
                  id={data.id}
                  startDatetime={moment(data.start_datetime).format(
                    "DD/MM/YYYY HH:mm"
                  )}
                  endDatetime={moment(data.end_datetime).format(
                    "DD/MM/YYYY HH:mm"
                  )}
                  qtaAvailable={data.spot_available}
                  viewButtonSubscription={false}
                />
              </Stack>
            </Col>
          ) : null}

          {!isEmpty(data.volunteer) || !isEmpty(data.waiting_volunteer) ? (
            <Col sm={12} lg={6} className="d-flex justify-content-center">
              <div className="container-on-right w-100 p-2">
                {/*Partecipanti al turno*/}
                {!isEmpty(data.volunteer) ? (
                  <Stack direction="vertical" gap={3}>
                    <span className="title-container">
                      {t("shift_details.volunteer_subscribed_shift")}
                    </span>
                    <Stack direction="vertical" gap={2}>
                      {data.volunteer.map((item, index) => (
                        <VolunteerDetails
                          key={index}
                          image={
                            !isEmpty(item.image) && !isEmpty(item.image_type)
                              ? "data:" +
                                item.image_type +
                                ";base64," +
                                item.image
                              : "/no_img.png"
                          }
                          name={item.name}
                          surname={item.surname}
                          phoneNumber={item.tel}
                          email={item.email}
                          listSettingsVoice={[
                            {
                              name: t("shift_details.remove_volunteer.name"),
                              icon: (
                                <DeleteOutlinedIcon
                                  style={{
                                    color: "red",
                                    width: " 20px",
                                    height: "20px",
                                  }}
                                />
                              ),
                              callback: () => {
                                removeSubscriptionVolunteerWS({
                                  id_shift: data.id,
                                  id_user: item.id,
                                })
                                  .then((res) => {
                                    gestioneSnackbar(
                                      true,
                                      res.message,
                                      "success"
                                    );
                                    refreshContent();
                                  })
                                  .catch((err) =>
                                    gestioneSnackbar(true, err.message, "error")
                                  );
                              },
                              color: "red",
                              customDialog: true,
                              titleModal: t(
                                "shift_details.remove_volunteer.title"
                              ),
                              descriptionModal: t(
                                "shift_details.remove_volunteer.description"
                              ),
                            },
                          ]}
                        />
                      ))}
                    </Stack>
                  </Stack>
                ) : null}

                {/*Volontari in attesa*/}
                {!isEmpty(data.waiting_volunteer) ? (
                  <Stack direction="vertical" gap={3} className="mt-3">
                    <span className="title-container">
                      {t("shift_details.waiting_volunteer_shift")}
                    </span>
                    <Stack direction="vertical" gap={2}>
                      {data.waiting_volunteer.map((item, index) => (
                        <WaitingUserBox
                          key={index}
                          idUserShift={item.id_user_shift}
                          name={item.name}
                          surname={item.surname}
                          imageProfile={
                            !isEmpty(item.image) && !isEmpty(item.image_type)
                              ? "data:" +
                                item.image_type +
                                ";base64," +
                                item.image
                              : "/no_img.png"
                          }
                          handleClick={handleClick}
                        />
                      ))}
                    </Stack>
                  </Stack>
                ) : null}
              </div>
            </Col>
          ) : null}
        </Row>
        <VoidSpace />
      </div>
    </>
  );
};

export default ShiftDetails;
